<div class="bg-blue-5 flex flex-wrap items-center justify-between gap-3 border-b border-steel-10 px-4 py-3">
  <div>
    <h2 class="m-0 text-heading-3">{{ heading() }}</h2>
    @if (subheading(); as subheading) {
      <p class="m-0 mt-1 text-sm text-steel-70" data-id="comparison-table-subheading">{{ subheading }}</p>
    }
  </div>
  <ng-content select="[rmaComparisonTableActions]" />
</div>

<div rmaScrollSync role="table" class="scrollbar-none overflow-x-auto" [attr.aria-label]="heading()">
  <ng-content />
</div>
